import React from 'react';
import Icon from '../Icon/Icon';

const GenericError = () => {
  return (
    <div className="wmcads-msg-summary wmcads-msg-summary--error wmcads-m-b-lg">
      <div className="wmcads-msg-summary__header">
        <Icon iconName="general-warning-triangle" className="wmcads-msg-summary__icon" />
        <h3 className="wmcads-msg-summary__title">There is a problem</h3>
      </div>

      <div className="wmcads-msg-summary__info">Please check your answers again.</div>
    </div>
  );
};

export default GenericError;
